import { createWeightColumnDefinition } from './weight-column-helper';
import { messages } from '../messages';

export const createMaxWeightColumnDefinition = createWeightColumnDefinition({
  accessor: 'maxWeight',
  headerMessage: messages.maxWeightColumnHeader,
});
